<template>
  <pie-chart :chart-data="chartData" :options="options" :height="height" />
</template>

<script>
import {Pie} from 'vue-chartjs';

const PieChart = {
  extends: Pie,
  props: ['chartData', 'options', 'height'],
  mounted() {
    this.renderChart(this.chartData, this.options);
  }
};

export default {
  name: 'AttendancePieChart',
  components: {PieChart},
  props: {
    stats: {type: Object, required: true},
    variant: {type: String, required: true},
    height: {type: [Number, String], default: 350}
  },
  computed: {
    chartData() {
      const stats = this.stats || {};
      const isLogin = this.variant === 'login';
      const labels = isLogin ?
        [
          this.$t('models.dashboard.attributes.lateLogins'),
          this.$t('models.dashboard.attributes.normalLogins'),
          this.$t('models.dashboard.attributes.missingLogins')
        ] :
        [
          this.$t('models.dashboard.attributes.earlyLogouts'),
          this.$t('models.dashboard.attributes.normalLogouts'),
          this.$t('models.dashboard.attributes.missingLogouts')
        ];
      const data = isLogin ?
        [stats.late_logins, stats.normal_logins, stats.missing_logins] :
        [stats.early_logouts, stats.normal_logouts, stats.missing_logouts];
      return {
        labels,
        datasets: [
          {
            label: isLogin ?
              this.$t('models.dashboard.attributes.loginPieChart') :
              this.$t('models.dashboard.attributes.logoutPieChart'),
            backgroundColor: ['#dc2626', '#16a34a', '#2563eb'],
            borderColor: ['#000000', '#000000', '#000000'],
            borderWidth: 2,
            data
          }
        ]
      };
    },
    options() {
      const vm = this;
      return {
        responsive: true,
        maintainAspectRatio: false,
        tooltips: {
          callbacks: {
            label(tooltipItem, data) {
              const dataset = data.datasets?.[tooltipItem.datasetIndex] || {};
              const values = dataset.data || [];
              const value = values?.[tooltipItem.index] ?? 0;
              const percentage = vm.calculatePercentage(values, tooltipItem.index);
              const label = data.labels?.[tooltipItem.index] || '';
              return `${label}: ${value} (${percentage}%)`;
            }
          }
        },
        legend: {
          position: 'bottom',
          labels: {
            padding: 15,
            usePointStyle: true,
            generateLabels(chart) {
              const data = chart.data || {};
              if ((data.labels?.length || 0) && (data.datasets?.length || 0)) {
                const dataset = data.datasets[0] || {};
                const values = dataset.data || [];
                return (data.labels || []).map((label, index) => {
                  const value = values?.[index] ?? 0;
                  const percentage = vm.calculatePercentage(values, index);
                  return {
                    text: `${label}: ${value} (${percentage}%)`,
                    fillStyle: dataset.backgroundColor?.[index],
                    strokeStyle: dataset.borderColor?.[index],
                    lineWidth: dataset.borderWidth,
                    hidden: false,
                    index
                  };
                });
              }
              return [];
            }
          }
        }
      };
    }
  },
  methods: {
    calculatePercentage(values, index) {
      const safeValues = Array.isArray(values) ? values : [];
      const total = safeValues.reduce((sum, v) => sum + (Number.isFinite(v) ? v : 0), 0);
      const value = Number.isFinite(safeValues[index]) ? safeValues[index] : 0;
      return total ? ((value / total) * 100).toFixed(1) : '0.0';
    }
  }
};
</script>


